/** Build the *only* fields the synthetic Campaign Director API accepts. */
export function createDraftPayload(instruction, requestedLeadTarget) {
  const clean = typeof instruction === 'string' ? instruction.trim() : '';
  const amount = String(requestedLeadTarget).trim();
  if (clean.length < 10 || clean.length > 2000) {
    throw new Error('Enter a campaign instruction between 10 and 2,000 characters.');
  }
  if (!/^\d+$/.test(amount)) {
    throw new Error('Lead target must be a whole number.');
  }
  const lead_target = Number(amount);
  if (lead_target < 1 || lead_target > 100) {
    throw new Error('Lead target must be between 1 and 100.');
  }
  return { instruction: clean, product: 'final_expense', state: 'FL', lead_target };
}
